module.exports = "/images/pl.svg";